import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  welcomeMessage: 'Hi there!👋 <br><br> How can I help you?',
  buttonText: 'Start Chat with:',
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/app-chats-message-bubble-multicolor.svg'
  },
  buttonsColor: {
    type: 'native',
    color: 'rgb(0, 132, 255)'
  }
};
